import { RESET_COMPARISON_SUCCESS } from '../Comparator/Comparator.actions'
import {
  COMPARATOR_TRADED_SECTORS,
  COMPARATOR_TRADED_SECTORS_SUCCESS,
  COMPARATOR_TRADED_SECTORS_ERROR,
  COMPARATOR_TRADED_BY,
  COMPARATOR_TRADED_BY_SUCCESS,
  COMPARATOR_TRADED_BY_ERROR
} from './ComparatorTradedBy.actions'

const initialState = {
  data: {
    categories: [],
    amounts: [],
    csvStructure: []
  },
  sector: [],
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator Traded By's reducer.
 */
const comparatorTradedByReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARATOR_TRADED_BY: {
      return { ...state, fetching: true }
    }
    case COMPARATOR_TRADED_BY_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case COMPARATOR_TRADED_BY_ERROR: {
      return { ...state, error: payload }
    }
    case COMPARATOR_TRADED_SECTORS: {
      return { ...state, fetching: true }
    }
    case COMPARATOR_TRADED_SECTORS_SUCCESS: {
      return { ...state, sector: payload, fetching: false, fetched: true }
    }
    case COMPARATOR_TRADED_SECTORS_ERROR: {
      return { ...state, error: payload }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorTradedByReducer
